module.exports = __webpack_public_path__ + "static/media/introduce_base5.ac5500e9.png";